import React from "react";
import ChangePasswordForm from "./ChangePasswordForm";

function ChangePasswordPage() {
  return <ChangePasswordForm />;
}

export default ChangePasswordPage;
